<template>
  <CDialog>
    <el-dialog title="葱花投研" :visible.sync="dialog_show" width="75%" destroy-on-close>
      <div style="height: 60vh">
        <div
          style="
            margin-top: -20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 15px;
          ">
          <div
            style="
              display: flex;
              align-items: center;
              color: var(--chart_title);
              font-size: calc(var(--ROOTFONTFIZE) * (18 / 144));
            ">
            {{ name }}
            <div style="font-size: calc(var(--ROOTFONTFIZE) * (14 / 144))">
              <el-checkbox v-model="del_dq" @change="loadData" /> 剔除倒券
            </div>
          </div>
          <div>
            <Download
              :dButtonsDownloads="dButtonsDownloads"
              :excel_info="excel_info1"
              echartRefName="dwn1sdgfs_rnkRef" />
          </div>
        </div>
        <el-table
          class="table1"
          :header-cell-style="styleBindFun"
          :data="block_trading_detail"
          height="95%"
          style="width: 100%">
          <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
          <el-table-column align="center" prop="交易日期" sortable label="交易日期" width="130">
          </el-table-column>
          <el-table-column align="center" prop="交易单价" sortable label="成交价格" width="130">
          </el-table-column>
          <el-table-column
            align="center"
            prop="交易量(万元)"
            sortable
            label="成交量(万)"
            width="130">
          </el-table-column>
          <el-table-column
            align="center"
            prop="交易额(万元)"
            sortable
            label="成交额(万)"
            width="130">
          </el-table-column>
          <el-table-column align="center" prop="买方" label="买方"> </el-table-column>
          <el-table-column align="center" prop="卖方" label="卖方"> </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </CDialog>
</template>

<script>
import CDialog from '@/components/Basic/CDialog';
import Download from '../Basic/Download.vue';
import { fnReturnTableStyle } from '@/utils/util';

export default {
  props: {
    show: Boolean,
    code: String,
    name: String,
    start_date: String,
    end_date: String,
    d_dq: Boolean,
  },
  components: { CDialog, Download },
  data() {
    return {
      del_dq: false,
      block_trading_detail: [],
      dButtonsDownloads: Object.freeze([
        /* {
          id: '241020',
          name: '下载图片',
        }, */
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      excel_info1: Object.freeze({
        /*overviewName: '',
          excel_data:[],
          json_fields:{}
        */
      }),
    };
  },
  computed: {
    dialog_show: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
  },
  watch: {
    show(n) {
      if (n) {
        // if (this.d_dq) this.del_dq = true;
        this.del_dq = this.d_dq;
        this.loadData();
      }
    },
  },
  methods: {
    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      return fnReturnTableStyle(val);
    },
    async loadData() {
      const del_dq = this.del_dq ? 1 : 0;
      const { data } = await this.$https.get(
        `/api/v2/blocktrade_detail?code=${this.code}&del_dq=${del_dq}&start_date=${this.start_date}&end_date=${this.end_date}`
      );

      if (data.code !== 200) return this.$message.error(data.msg);
      this.block_trading_detail = data.data;
      this.excel_info1 = Object.freeze({
        overviewName: '',
        excel_data: data.data,
        json_fields: {
          交易日期: '交易日期',
          成交价格: '交易单价',
          '成交量(万)': '交易量(万元)',
          '成交额(万)': '交易额(万元)',
          买方: '买方',
          卖方: '卖方',
        },
      });
    },
  },
};
</script>
